import {
  pt9800GraphqlClientQuery,
} from './client';

import {
  actRecipeVersion,
  furnaceView,
  recipeMetadata,
  shopLayoutMenuItems,
} from '@/utils/pt9800-zeus';

export async function getRecipeMetadata({
  ptDbId,
  workplaceId,
  recipePrefix,
}: {
  ptDbId: number,
  workplaceId: number,
  recipePrefix: string,
}) {
  return pt9800GraphqlClientQuery({
    getRecipeMetadata: [
      {
        workplaceId,
        recipePrefix,
      },
      recipeMetadata,
    ],
  }, {
    variables: {
      location: ptDbId,
    },
  });
}

export async function getActualRecipeOfWorkplace(ptDbId: number, workplaceId: number) {
  return pt9800GraphqlClientQuery({
    actualRecipeOfWorkplace: [
      {
        workplaceId,
      },
      actRecipeVersion,
    ],
  }, {
    variables: {
      location: ptDbId,
    },
  });
}

export async function listOfAvailableFurnaces(location: string) {
  return pt9800GraphqlClientQuery({
    listOfAvailableFurnaces: true,
    cptEntries: {
      id: true,
    },
  }, {
    variables: {
      location,
    },
  });
}

export async function getFurnaceView(ptDbId: number, workplaceId: number) {
  return pt9800GraphqlClientQuery({
    furnaceView: [
      {
        workplaceId,
      },
      furnaceView,
    ],
  }, {
    variables: {
      location: ptDbId,
    },
  });
}

export async function getShopLayoutMenuItem(ptDbId: number) {
  return pt9800GraphqlClientQuery({
    shopLayoutMenuItems,
  }, {
    variables: {
      location: ptDbId,
    },
  });
}

export type TGetFurnaceViewResponse = Awaited<ReturnType<typeof getFurnaceView>>;
